// extracted by mini-css-extract-plugin
export default {"separator":"NftTransactions_separator__xKY9C"};